class Consent {
  constructor() {
    this.init = this.init.bind(this);
    this.handleConsent = this.handleConsent.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }

  async init() {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          console.error('Error loading features: ', error);
          return;
        }
        console.log('Consent tracking API loaded');
        this.initConsentComponent();
      }
    );
  }

  async initConsentComponent() {
    window.dataLayer = window.dataLayer || [];

    document.addEventListener('visitorConsentCollected', async () => {
      this.handleConsent('update');
    });

    const userHasInteractedWithConsentBanner = await this.checkConsentBannerInteraction();
    if (!userHasInteractedWithConsentBanner) {
      this.handleConsent('default');
    }

    const recallConsentElement = document.getElementById('recall-consent');
    if (recallConsentElement) {
      recallConsentElement.addEventListener('click', (event) => {
        event.preventDefault();
        this.recallConsent();
      });
    }
  }

  async handleConsent(state) {
    const visitorConsent = await window.Shopify.customerPrivacy.currentVisitorConsent();

    const consent = {
      functionality_storage: visitorConsent.preferences === 'yes' ? 'granted' : 'granted',
      analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
      personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
      ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
      ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
      ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
      wait_for_update: 500,
    };

    this.gtag('consent', state, consent);

    localStorage.setItem('consentSettings', JSON.stringify(consent));
  }

  async checkConsentBannerInteraction() {
    const visitorConsent = await window.Shopify.customerPrivacy.currentVisitorConsent();
    if (visitorConsent.preferences === '' && visitorConsent.analytics === '' && visitorConsent.marketing === '') {
      return false;
    }

    return true;
  }

  gtag(...args) {
    window.dataLayer.push(arguments);
  }

  async recallConsent() {
    window.privacyBanner.showPreferences();
  }
}
const consent = new Consent();
consent.init();
